import * as React from "react";

const s = require("./input1.scss");

interface Props {
    input: {
        value: string;
        onChange: any;
        onBlur?: any;
        onFocus?: any;
    };
}

function parse(e: React.FormEvent<HTMLInputElement>) {
    return (e.target as HTMLInputElement).value;
}

class Input1 extends React.Component<Props, {}> {
    render() {
        return (
            <input
                type="text"
                onChange={event => this.props.input.onChange(parse(event))}
                value={this.props.input.value}
                onBlur={event => this.props.input.onBlur(parse(event))}
                onFocus={event => this.props.input.onFocus()}
                className={s.form1Input1}
            />
        );
    }
}

export default Input1;



// WEBPACK FOOTER //
// ./src/components/FormElements/Inputs/Input1/index.tsx